'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _Teaser = require('./Teaser');

var _Teaser2 = _interopRequireDefault(_Teaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-teaser-small')(_Teaser2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-teaser-small/lib/cjs/index.js
 ** module id = 529
 ** module chunks = 1
 **/